module.exports = __webpack_public_path__ + "static/media/valentino.177cfc47.png";